import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { a as EGDSIcon } from '../icon/index-chunk.esm.js';
import { c as classNames, b as EGDSContextWrapper } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-switch.css';
const getClassNameList$1 = classNames.bind(styles);
class EGDSSwitch extends React.Component {
  static displayName = 'EGDSSwitch';
  static defaultProps = {
    checked: false,
    switchPosition: 'leading'
  };
  render() {
    const {
      a11yLabel,
      checked,
      children,
      className,
      disabled,
      description,
      errorMessage,
      id,
      label,
      labelClassName,
      name,
      onChange,
      required,
      switchPosition,
      theme = 'standard',
      value
    } = this.props;
    const baseCssClass = 'uitk-switch';
    const wrapperClassNames = getClassNameList$1(baseCssClass, className, `${baseCssClass}-theme-${theme}`, `${baseCssClass}-position-${switchPosition}`, {
      'is-disabled': disabled
    });
    const labelCssClassNames = getClassNameList$1(`uitk-switch-label`, {
      [labelClassName]: Boolean(labelClassName),
      'is-required': required
    });
    const inputClassNames = getClassNameList$1(`${baseCssClass}-input`, {
      checked
    });
    const controlClassNames = getClassNameList$1(`${baseCssClass}-control`);
    const handleClassNames = getClassNameList$1(`${baseCssClass}-control-handle`);
    const contentClassNames = getClassNameList$1(`${baseCssClass}-content`);
    const labelContentClassNames = getClassNameList$1(`${baseCssClass}-label-content`);
    const descriptionClassNames = getClassNameList$1(`${baseCssClass}-description`);
    const errorClassNames = getClassNameList$1(`${baseCssClass}-error`);
    const contents = label || children;
    return jsx(EGDSContextWrapper, {
      children: (context, data) => jsxs("div", {
        className: wrapperClassNames,
        children: [jsx("input", {
          type: "checkbox",
          name: name || id,
          id: id,
          checked: checked,
          className: inputClassNames,
          onChange: onChange,
          value: value,
          "aria-invalid": errorMessage ? true : undefined,
          disabled: disabled,
          "aria-required": required,
          "aria-label": a11yLabel
        }), jsx("div", {
          "aria-hidden": "true",
          className: controlClassNames,
          children: jsx("div", {
            className: handleClassNames,
            children: jsx(EGDSIcon, {
              name: checked ? 'check' : 'close'
            })
          })
        }), jsxs("div", {
          className: contentClassNames,
          children: [jsxs("label", {
            className: labelCssClassNames,
            htmlFor: id,
            children: [jsxs("span", {
              className: labelContentClassNames,
              children: [contents, required && (data && !data?.hasRequiredFieldIndicator ? null : jsx("span", {
                className: getClassNameList$1('uitk-switch-required-asterisk'),
                children: " *"
              }))]
            }), description && jsx("p", {
              className: descriptionClassNames,
              children: description
            })]
          }), errorMessage && jsx("p", {
            className: errorClassNames,
            children: errorMessage
          })]
        })]
      })
    });
  }
}
const getClassNameList = classNames.bind(styles);
class EGDSFavoriteSwitch extends React.Component {
  static displayName = 'EGDSFavoriteSwitch';
  static defaultProps = {
    checked: false
  };
  render() {
    const {
      checked,
      className,
      disabled,
      id,
      label,
      labelClassName,
      name,
      onChange,
      value
    } = this.props;
    const baseClass = 'uitk-favorite-switch';
    const wrapperClassName = getClassNameList(baseClass, {
      'is-disabled': disabled
    });
    const inputClassNames = getClassNameList(className, `${baseClass}-input`);
    const labelCssClassName = getClassNameList(labelClassName, `${baseClass}-control`, {
      [`${baseClass}-input-is-checked`]: checked
    });
    const fillCssClassName = getClassNameList(`${baseClass}-fill`);
    const borderCssClassName = getClassNameList(`${baseClass}-border`);
    return jsx("div", {
      className: wrapperClassName,
      children: jsxs("label", {
        className: labelCssClassName,
        htmlFor: id,
        children: [jsx("input", {
          className: inputClassNames,
          type: "checkbox",
          name: name || id,
          id: id,
          checked: checked,
          onChange: onChange,
          value: value,
          "aria-label": label,
          disabled: disabled
        }), jsx(EGDSIcon, {
          name: "favorite",
          className: fillCssClassName
        }), jsx(EGDSIcon, {
          name: "favorite_border",
          className: borderCssClassName
        })]
      })
    });
  }
}
export { EGDSSwitch as E, EGDSFavoriteSwitch as a };